module.exports = __webpack_public_path__ + "img/2497.642f0396.png";